import { render, staticRenderFns } from "./EBikeDetailModal.vue?vue&type=template&id=72072cec&scoped=true"
import script from "./EBikeDetailModal.vue?vue&type=script&lang=js"
export * from "./EBikeDetailModal.vue?vue&type=script&lang=js"
import style0 from "./EBikeDetailModal.vue?vue&type=style&index=0&id=72072cec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72072cec",
  null
  
)

export default component.exports